import api from './api';

class RosterService {
  getRoster(teamId, leagueId) {
    let params = teamId ? `?teamId=${teamId}` : '';
    if (leagueId) params += (params ? `&leagueId=${leagueId}` : `?leagueId=${leagueId}`);
    return api.get(`secure/roster${params}`);
  }

  getAvailableGuests(teamId, leagueId) {
    let params = teamId ? `?teamId=${teamId}` : '';
    if (leagueId) params += (params ? `&leagueId=${leagueId}` : `?leagueId=${leagueId}`);
    return api.get(`secure/roster/guests${params}`);
  }

  updateRoster(teamId, roster, leagueId) {
    let params = teamId ? `?teamId=${teamId}` : '';
    if (leagueId) params += (params ? `&leagueId=${leagueId}` : `?leagueId=${leagueId}`);
    return api.post(`secure/roster${params}`, roster);
  }

  updateGuestRoster(teamId, roster, leagueId) {
    let params = teamId ? `?teamId=${teamId}` : '';
    if (leagueId) params += (params ? `&leagueId=${leagueId}` : `?leagueId=${leagueId}`);
    return api.post(`secure/roster/guests${params}`, roster);
  }

  lockRoster(teamId, leagueId) {
    let params = teamId ? `?teamId=${teamId}` : '';
    if (leagueId) params += (params ? `&leagueId=${leagueId}` : `?leagueId=${leagueId}`);
    return api.post(`secure/roster/lock${params}`);
  }
}

export default new RosterService();